export default "__VITE_ASSET__BsVF$6Tc__"